// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2t7Tb","requiredAsterisk":"Info_requiredAsterisk__1eSfD"};